<template>
  <w-sliding-popup type="setting" title="트랩 추가" ref="slidingPopup" width="1000px" @close="close()">
    <div slot="content">
      <el-row type="flex" justify="space-between">
        <el-col class="mr-r20" :span="6" type="flex" justify="space-between">
          <el-row class="title-bar vertical-center-box">
            <div class="title-h4 mr-r15">MIB 목록</div>
            <div class="setting-addel">
              <el-upload style="display: inline;" action="" :before-upload="(file) => file" :show-file-list="false" :auto-upload="false" :on-change="setFileData">
                <el-button size="mini" style="border-right: none;"><i class="fas fa-plus"></i></el-button>
              </el-upload>
              <el-button size="mini" :disabled="mibCheckedRow.length === 0" @click="deleteMib" style="margin-left: -5px;"><i class="fas fa-minus"></i></el-button>
            </div>
          </el-row>
          <el-row>
            <div>
              <el-table-wrapper ref="mibTable" :data="mibDatas" :columns="mibColumns" highlight-current-row :show-custom-header="true" :pagination="false" :show-search-tool="showSearchTool"
              @row-click="changeMib" @selection-change="mibSelectionChange">
              </el-table-wrapper>
            </div>
          </el-row>
        </el-col>
        <el-col :span="18">
          <div class="title-bar vertical-center-box title-h4">트랩 목록</div>
          <div class="title-bar">
            <span>선택한 트랩을 추가합니다.</span>
          </div>
          <el-table-wrapper :data="trapDatas" :columns="trapColumns" highlight-current-row :show-custom-header="true" :pagination="false" :show-search-tool="showSearchTool"
          @selection-change="trapSelectionChange">
          </el-table-wrapper>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onAddButton">추가</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtils from '@/utils/message';
import integratedTrapSettingAPI from '@/api/settings/log/integrated-trap-settings';

export default {
  name: 'WAddMibTrapPopup',
  props: {
    trapOriginDatas: Array,
  },
  data() {
    const mibColumns = [
      {
        type: 'selection',
        width: 45,
      },
      {
        prop: 'mibFile',
        label: 'MIB',
        align: 'center',
      },
    ];

    const trapColumns = [
      {
        type: 'selection',
        width: 45,
      },
      {
        prop: 'snmptrapName',
        label: '트랩명',
        headerAlign: 'center',
      },
      {
        prop: 'snmptrapOid',
        label: 'OID',
        headerAlign: 'center',
      },
      {
        prop: 'snmptrapVersion',
        label: '버전',
        headerAlign: 'center',
        width: '70px',
      },
      {
        prop: 'snmptrapGenericName',
        label: 'Generic',
        headerAlign: 'center',
      },
      {
        prop: 'snmptrapSpecificId',
        label: 'Specific',
        headerAlign: 'center',
        width: '110px',
        formatter: this.getStringFormatter,
      },
    ];

    return {
      mibDatas: [],
      mibColumns,
      trapDatas: [],
      trapColumns,
      mibCheckedRow: [],
      trapCheckedRow: [],
      showSearchTool: false,
      fileParams: null,
    };
  },
  methods: {
    /**
     * MIB 목록을 로드한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadMibList() {
      integratedTrapSettingAPI.getMibList().then((response) => {
        if (response.data.success) {
          this.mibDatas = response.data.data;
          if (isEmpty(this.mibDatas)) {
            this.trapDatas = [];
            return;
          }
          this.changeMib(this.mibDatas[0]);
          this.$nextTick(() => {
            this.$refs.mibTable.$children[0].setCurrentRow(this.mibDatas[0]);
          });
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'MIB', false));
        throw new Error(e);
      });
    },
    /**
     * MIB 선택이 변경되면 트랩 목록을 새로 갱신한다.
     * @author Minyeong
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    changeMib(row) {
      this.loadTrapList(row.mibFile);
    },
    /**
     * MIB로 트랩 목록을 로드한다.
     * @author Minyeong
     * @param  {[type]} mibName [description]
     * @return {[type]}         [description]
     */
    loadTrapList(mibName) {
      const params = {
        params: {
          mibName,
        },
      };
      integratedTrapSettingAPI.getMibTrapList(params).then((response) => {
        if (response.data.success) {
          this.trapDatas = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'MIB', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    mibSelectionChange(selection) {
      this.mibCheckedRow = selection;
    },
    trapSelectionChange(selection) {
      this.trapCheckedRow = selection;
    },
    /**
     * MIB file을 삭제한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    deleteMib() {
      this.$confirm(...msgUtils.getBasicConfirmData('MIB를 삭제')).then(() => {
        integratedTrapSettingAPI.deleteMibfile(this.mibCheckedRow).then((response) => {
          if (response.data.success) {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, 'MIB', response.data.success));
            this.loadMibList();
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, 'MIB', response.data.success));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, 'MIB', false));
          throw new Error(e);
        });
      });
    },
    /**
     * Trap 추가 버튼을 클릭하면 체크박스에 선택된 trap들을 trap목록에 추가한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onAddButton() {
      this.$confirm(...msgUtils.getCustomConfirmData('이미 등록된 트랩은 제외하고 추가됩니다.')).then(() => {
        const params = [];
        this.trapCheckedRow.forEach((item) => {
          const temp = {
            snmptrapVersion: item.snmptrapVersion,
            snmptrapOid: item.snmptrapOid.replace('.', ''),
            snmptrapSpecificId: item.snmptrapSpecificId,
          };
          const checkDupl = find(this.trapOriginDatas, temp);
          if (isEmpty(checkDupl)) {
            // 이미 등록된 트랩이 없을 경우
            item.applyFlag = 'Y';
            params.push(item);
          }
        });
        if (!isEmpty(params)) {
          integratedTrapSettingAPI.insertSnmptrap(params).then((response) => {
            if (response.data.success) {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '트랩', response.data.success));
              this.clickClose();
              this.$emit('reload-trap');
            } else {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '트랩', response.data.success));
            }
          }).catch((e) => {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '트랩', false));
            throw new Error(e);
          });
        } else {
          this.$message(msgUtils.getCustomMsgData('추가할 트랩이 없습니다.'));
        }
      });
    },
    setFileData(item) {
      this.fileParams = new FormData();
      this.fileParams.append('fileName', item.name);
      this.fileParams.append(item.name, item.raw);

      integratedTrapSettingAPI.insertMibfile(this.fileParams).then((response) => {
        if (response.data.success) {
          this.loadMibList();
          if (response.data.data === '저장되었습니다.') {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, 'MIB', response.data.success));
          } else {
            this.$message(msgUtils.getCustomResultMsgData(response.data.data, false));
          }
        } else {
          this.$message(msgUtils.getCustomResultMsgData(response.data.data, false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, 'MIB', false));
        throw new Error(e);
      });
    },
    open() {
      this.$refs.slidingPopup.open();
      this.loadMibList();
    },
    close() {
      this.mibCheckedRow = [];
      this.trapCheckedRow = [];
      this.trapDatas = [];
      this.mibDatas = [];
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/popup/AddMibTrapPopup.vue